module.exports = __webpack_public_path__ + "static/media/Dark Brown 08.291741da.jpg";